module.exports = __webpack_public_path__ + "static/media/dragon.66dcea8d.png";